import { QueryClient, QueryClientProvider } from "react-query";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import * as Cognito from "./cognito";
import * as Axios from "./axios";
import * as User from "./user";

type Props = {
  children: JSX.Element;
};

const queryClient = new QueryClient();

export default function AppProviders({ children }: Props) {
  return (
    <Cognito.CognitoProvider>
      <Axios.AxiosProvider>
        <User.UserProvider>
          <QueryClientProvider client={queryClient}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {children}
            </LocalizationProvider>
          </QueryClientProvider>
        </User.UserProvider>
      </Axios.AxiosProvider>
    </Cognito.CognitoProvider>
  );
}
